export const ALLOWED_PHONE_KEYS = new Set([
    'Backspace', 'Delete', 'Tab',
    'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown',
    'Home', 'End',
]);

export const handlePhoneKeyDown = (e: KeyboardEvent) => {
    // Always allow control keys
    if (
        ALLOWED_PHONE_KEYS.has(e.key) ||
        e.ctrlKey ||
        e.metaKey
    ) {
        return;
    }

    // Block non-digit keys
    if (!/^\d$/.test(e.key)) {
        e.preventDefault();
        return;
    }

    // Block digit keys if input already has 10 digits (prevents key-hold overflow)
    const currentDigits = (e.target as HTMLInputElement).value?.replaceAll(/\D/g, "") ?? "";
    if (currentDigits.length >= 10) {
        e.preventDefault();
    }
};

export const formatPhoneNumber = (value: string): string => {
    const numericValue = value.replaceAll(/\D/g, "").slice(0, 10);
    if (numericValue.length > 6) {
        return `${numericValue.slice(0, 3)}-${numericValue.slice(3, 6)}-${numericValue.slice(6)}`;
    }
    if (numericValue.length > 3) {
        return `${numericValue.slice(0, 3)}-${numericValue.slice(3)}`;
    }
    return numericValue;
};